import styled from 'styled-components'
import { COLOURS } from 'resources'

export const ViewLayer = styled.div`
  ${({ $zIndex }) => $zIndex && `z-index: ${$zIndex};`}
`

export const SpinnerContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  width: 100%;
  margin-top: 20px;
`

export const ErrorMessage = styled.div`
  margin-top: 10px;
  color: ${COLOURS.errorText};
`
